import { useState } from 'react';
import {
  CreatePermissionGate,
  ReadPermissionGate,
} from 'components/PermissionGate';
import { PERMISSION_RESOURCES } from 'constants/permissions';
import { ComposeForm } from './components/ComposeForm';
import { HistoryTable } from './components/HistoryTable';

export const PublicNotifications = () => {
  // Bumped after a create so the history table refetches immediately
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <ReadPermissionGate
      resource={PERMISSION_RESOURCES.PUBLIC_NOTIFICATIONS}
      fallback={
        <div className="mt-5 text-center text-gray-600 dark:text-white">
          You don't have access to the Notifications page.
        </div>
      }
    >
      <div className="mt-3 grid grid-cols-1 gap-5 xl:grid-cols-2">
        <CreatePermissionGate
          resource={PERMISSION_RESOURCES.PUBLIC_NOTIFICATIONS}
        >
          <ComposeForm onCreated={() => setRefreshKey(k => k + 1)} />
        </CreatePermissionGate>
        <HistoryTable refreshKey={refreshKey} />
      </div>
    </ReadPermissionGate>
  );
};

export default PublicNotifications;
